import { ScrollView, View } from 'react-native';
import { COLOR, RADIUS, SPACING } from 'constants/design-system';

import type { ReactNode } from 'react';
import type { ScrollViewProps } from 'react-native';
import type { ViewProps } from 'react-native-svg/lib/typescript/fabric/utils';

export type BaseCardProps = {
  children?: ReactNode;
  scrollable?: boolean;
} & Pick<
  ViewProps & ScrollViewProps,
  'style' | 'contentContainerStyle' | 'stickyHeaderIndices'
>;

export const BaseCard = (props: BaseCardProps) => {
  const {
    children,
    style,
    scrollable,
    contentContainerStyle,
    stickyHeaderIndices,
  } = props;

  const ContainerElement = scrollable ? ScrollView : View;

  return (
    <ContainerElement
      style={[
        {
          overflow: scrollable ? 'scroll' : 'hidden',
          backgroundColor: COLOR.theme.white,
          borderRadius: RADIUS.theme.md,
          padding: scrollable ? undefined : SPACING.theme[8],
          paddingHorizontal: scrollable ? SPACING.theme[8] : undefined,
        },
        style,
      ]}
      contentContainerStyle={[
        {
          paddingVertical: scrollable ? SPACING.theme[8] : undefined,
        },
        contentContainerStyle,
      ]}
      stickyHeaderIndices={stickyHeaderIndices}
    >
      {children}
    </ContainerElement>
  );
};
